// languages/de.js
export const de = {
  // UI Text
  ui: {
    title: "Haunted House of Dark Data",
    subtitle: "Eine interaktive Reise durch die Probleme ungenutzter Unternehmensdaten",
    blogReference: "Basierend auf dem FELD M",
    blogLinkText: "Blog-Artikel",
    blogLinkSuffix: "über Dark Data",
    loadingNextRoom: "Lade nächsten Raum...",
    roomLoading: "Raum wird geladen...",
    restartGame: "Erneut das Haunted House erkunden",
    backButton: "Zurück",
    language: "Sprache",
    visitFeldM: "Besuchen Sie FELD M",
    learnMore: "Mehr erfahren"
  },

  // Ending Messages
  endings: {
    success: {
      title: "Data Excellence erreicht!",
      message: "Glückwunsch! Sie haben erkannt, dass klare Use Cases der Schlüssel zur Vermeidung von Dark Data sind. Mit konkreten Geschäftsfragen und strategischer Datennutzung verwandeln Sie Ihr Datenhaus in eine wertschöpfende Ressource."
    },
    failure: {
      title: "Daten-Disaster!",
      message: "Deine unüberlegten Aktionen haben zu Datenverlust oder unkalkulierbaren Risiken geführt. Dark Data erfordert eine durchdachte Strategie, nicht voreilige Lösungen."
    },
    awareness: {
      title: "Bewusstsein geschaffen",
      message: "Sie haben die wahren Kosten von Dark Data erkannt. Diese Erkenntnis ist der erste Schritt zu einer besseren Data Governance. Jetzt können Sie mit FELD M eine nachhaltige Datenstrategie entwickeln."
    },
    neutral: {
      title: "Die Reise geht weiter...",
      message: "Ihr Rundgang durch das Haunted House of Dark Data hat gezeigt, wie vielschichtig und vernetzt die Herausforderungen sind. Doch jetzt stellt sich die entscheidende Frage: Wo wollen Sie ansetzen, um Ihr Datenhaus in den Griff zu bekommen?"
    }
  },

  // Services
  services: {
    dataStrategy: {
      title: "Data Strategy & Governance",
      description: "Entwicklung einer nachhaltigen Datenstrategie mit klaren Use Cases"
    },
    dataArchitecture: {
      title: "Data Architecture",
      description: "Aufbau robuster Datenarchitekturen für optimale Datennutzung"
    },
    dataGovernance: {
      title: "Data Governance",
      description: "Etablierung von Prozessen und Strukturen zur Kontrolle und Sicherheit ihrer Datenbestände"
    },
    dataEngineering: {
      title: "Data Architecture",
      description: "Unterstützung bei der Konzeption sowie Auswahl und Einsatz notwendiger Technologien."
    },
    dataAnalytics: {
      title: "Data Analytics & Insights",
      description: "Kostentransparenz und ROI-Bewertung Ihrer Datenbestände"
    },
    dataAssessment: {
      title: "Data Assessment",
      description: "Bewertung und Inventarisierung Ihrer aktuellen Datensituation"
    },
    dataStrategyConsulting: {
      title: "Data Strategy Consulting",
      description: "Aufbau von Rollen, Prozessen und Regeln für Ihre Daten."
    },
    dataArchitectureConsulting: {
      title: "Data Architecture Consulting",
      description: "Unterstützung bei der Auswahl, Modernisierung und Einsatz notwendiger Technologien."
    }
  },

  // Company Info
  company: {
    helpTitle: "Wie FELD M helfen kann:",
    description: "Mit Expertise in Data Strategy, Datenarchitektur und Data Governance sorgen wir dafür, dass Ihre Daten zugänglich, zuverlässig und optimal genutzt werden."
  },

  // Next Steps
  nextSteps: {
    title: "Mögliche nächste Schritte:",
    intro: "Der wichtigste Schritt: Daten von Anfang an in hoher Qualität erfassen und verarbeiten unterstützt durch klare Prozesse und Verantwortlichkeiten. Je später Qualitätsprobleme entdeckt und korrigiert werden, desto aufwändiger und teurer wird es.",
    steps: {
      inventory: "Daten inventarisieren & Verantwortlichkeiten festlegen: Was existiert, wer besitzt es, welche Regulierungen (DSGVO …) gelten?",
      quality: "Datenqualität messen & sichern: Definieren Sie KPIs (Vollständigkeit, Genauigkeit …) und etablieren Sie Quality Gates im Workflow.",
      prioritize: "Use Cases priorisieren: Aufwand und Nutzen anhand des Inventars bewerten, um fokussiert vorzugehen.",
      pilot: "Pilotprojekt mit klaren Erfolgskriterien starten: Schnell Wert liefern, Learnings dokumentieren und Skalierung planen."
    }
  }
};